import { LoaderFunction } from 'react-router-dom';

import { fetchGraphQL } from 'src/services/contentful/client';
import {
  ContentfulContentHub,
  GET_CONTENT_HUB_COLLECTION,
  GetContentHubCollectionResponse,
} from 'src/graphql/queries/GetContentHub';
import { GetContentHubCollectionQueryVariables } from 'src/graphql/generated/GetContentHub';
import { ContentHubType } from 'src/constants';
import { isPreviewMode } from 'src/utils/isPreviewMode';

export interface ResourcesAndSupportHubLoaderProps {
  resourcesAndSupportHubData: ContentfulContentHub;
}

const getResourcesAndSupportHubData = async (
  type: string,
  preview: boolean,
): Promise<ContentfulContentHub | undefined> => {
  const response = await fetchGraphQL<GetContentHubCollectionResponse, GetContentHubCollectionQueryVariables>(
    GET_CONTENT_HUB_COLLECTION,
    {
      preview,
      type,
    },
  );

  return response.contentHubCollection.items[0];
};

export const loader: LoaderFunction = async (): Promise<ResourcesAndSupportHubLoaderProps> => {
  const preview = isPreviewMode();

  const resourcesAndSupportHubData = await getResourcesAndSupportHubData(ContentHubType.RESOURCES_AND_SUPPORT, preview);

  if (!resourcesAndSupportHubData) {
    throw new Error('Resources and Support Hub was not found');
  }

  return { resourcesAndSupportHubData };
};
